// Studyo Today Backend
// Package studyo.today.sel.v1.resources
// Resource definitions
// Copyright (c) 2015-2022 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/sel/v1/resources/aggregation_strategy.proto (package studyo.today.sel.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/sel/v1/resources/aggregation_strategy.proto.
 */
export const file_studyo_today_sel_v1_resources_aggregation_strategy = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvc2VsL3YxL3Jlc291cmNlcy9hZ2dyZWdhdGlvbl9zdHJhdGVneS5wcm90bxIdc3R1ZHlvLnRvZGF5LnNlbC52MS5yZXNvdXJjZXMqhQEKE0FnZ3JlZ2F0aW9uU3RyYXRlZ3kSJAogQUdHUkVHQVRJT05fU1RSQVRFR1lfVU5TUEVDSUZJRUQQABIdChlBR0dSRUdBVElPTl9TVFJBVEVHWV9OT05FEAESKQolQUdHUkVHQVRJT05fU1RSQVRFR1lfTEFTVF9PRl9FQUNIX0RBWRACQiWqAiJTdHVkeW8uVG9kYXkuU2VsLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.sel.v1.resources.AggregationStrategy.
 */
export const AggregationStrategySchema = /*@__PURE__*/
  enumDesc(file_studyo_today_sel_v1_resources_aggregation_strategy, 0);

/**
 * Represents the possible aggregation strategies when returning emotional pulses.
 *
 * @generated from enum studyo.today.sel.v1.resources.AggregationStrategy
 */
export const AggregationStrategy = /*@__PURE__*/
  tsEnum(AggregationStrategySchema);

